import React from "react";
import "./banner.scss";

const Banner = () => {

  return (
    <>
      <div className="outter_layer_builders">
        <section className="banner-main">
          <img
            src="\assets\homepage\banner\banner-shadow.png"
            alt="img"
            className="img-fluid banner-shadow"
          />
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="\assets\bannervideo.mp4" type="video/mp4" />
          </video>
          <div className="custom-container">
            <div className="inner-banner">
              <div className="left-side">
                <div>
                  <h2>Architecting the Next Era of Prediction Markets</h2>
                  <p>
                    Launch your independent platform with Rain’s AI-ready SDK.
                    Apply for grants and earn a share of your generated trading
                    volume{" "}
                  </p>
                  <div className="twice-btns">
                    <a
                      href="https://rain.one/docs/For-Developers"
                      className="btn-docs"
                      target="_blank"
                    >
                      SDK
                    </a>
                    <a href="#program" className="btn-grant">
                      Builder Grants
                    </a>
                  </div>
                </div>
              </div>
              <div className="right-side">
                 <div className="main-img">
                  {
                    window.innerWidth > 991 ? <img src="\assets\builders\builder-main.png" alt="img" className="img-fluid" /> :
                      <img src="\assets\builders\builder-mainmbl.png" alt="img" className="img-fluid" />
                  }
                </div>


              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Banner;
